import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@hq-core/models/app-settings';
import { DataResource } from '@hq-custom-types';
import { Observable } from 'rxjs';
import {
    ReportExportRequest
} from './internal-export.model';

@Injectable({
    providedIn: 'root',
})
export class ReportExportResource implements DataResource<ReportExportRequest> {
    private readonly baseUrl: string;

    constructor(private http: HttpClient, private appSettings: AppSettings) {
        this.baseUrl = `${this.appSettings.apis.user}/report-export`;
    }

    create(request: ReportExportRequest): Observable<ReportExportRequest> {
        return this.http.post<ReportExportRequest>(this.baseUrl, request);
    }
}
